module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page3 animated fadeIn"
  }, [_c('img', {
    staticClass: "paddle",
    attrs: {
      "src": "media/global/paddle.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "main-info"
  }, [_c('h3', {
    staticClass: "main-title"
  }, [_vm._v(_vm._s(_vm.items.page4.title))]), _vm._v(" "), _c('p', {
    staticClass: "main-text",
    domProps: {
      "innerHTML": _vm._s(_vm.items.page4.text)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "node-holder"
  }, _vm._l(((this.path)), function(item, index) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.detailsViewMode || _vm.detailsViewMode && _vm.selectedNode === item.nodeID),
        expression: "!detailsViewMode || detailsViewMode && selectedNode === item.nodeID"
      }],
      class: {
        selected: _vm.detailsViewMode && _vm.selectedNode === item.nodeID
      },
      on: {
        "click": function($event) {
          _vm.nodeRouter(item, index)
        }
      }
    }, [_c('div', {
      staticClass: "each-node"
    }, [_c('img', {
      attrs: {
        "src": item.nodeIcon
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "text-holder"
    }, [_c('p', [_vm._v(_vm._s(item.nodeTitle))])]), _vm._v(" "), _c('img', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.state.completedNodes[index]),
        expression: "state.completedNodes[index]"
      }],
      staticClass: "checkmark",
      attrs: {
        "src": "media/page4/checkmark.png"
      }
    })])])
  })), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "detail-transition",
      "enter-active-class": "animated fadeIn"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.detailsViewMode === true),
      expression: "detailsViewMode === true"
    }],
    staticClass: "detail-holder"
  }, [_c('p', [_vm._v(_vm._s(this.selectedNodePath.detailText))]), _vm._v(" "), _c('div', {
    staticClass: "detail-continue",
    on: {
      "click": function($event) {
        _vm.continueRouter()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "media/global/btn_continue.png"
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.items.globalButtons.continueButton))])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-39bb0e8a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/containers/section1/pages/Page3.vue
// module id = 134
// module chunks = 0